import SynologyImg from '../../../assets/images/itmonkeys-synology.png';
import NASImg from '../../../assets/images/itmonkeys-nas.png';
import SyncImg from '../../../assets/images/itmonkeys-sync.png'
import SecImg from '../../../assets/images/itmonkeys-sec.png'
import ContactIMG from '../../../assets/images/itmonkeys-contact.png'
import CameraIMG from '../../../assets/images/itmonkeys-camera.png'
import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import { Services } from './types';
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

export interface Service {
  id: number;
  icon: string;
  mobileIcon: string;
  alt: string;
  title: string;
  titleKey?: string;
  description: string;
  descriptionKey?: string;
  link: string;
  features: { text: string; textKey?: string }[];
}

export const services: Services[] = [
  {
    id: 1,
    alt: 'IT Monleys NAS Synology.',
    title: 'Déploiement Accéléré',
    titleKey: 'appCloud.benefits.items.deploymentSpeed.title',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    leftTitle: 'Centralisez vos données',
    description: 'Avec notre expertise, déployez vos applications en temps réel. Libérez-vous des préparatifs laborieux et concentrez-vous sur l\'innovation, pour répondre rapidement à la demande du marché.',
    descriptionKey: 'appCloud.benefits.items.deploymentSpeed.description',
    link: '/#',
    features: [
      { text: 'Une fiabilité absolue et des performances constantes.', textKey: 'appCloud.benefits.items.deploymentSpeed.features.0' },
      { text: 'D\'importantes capacités de stockage qui peut être facilement étendues.', textKey: 'appCloud.benefits.items.deploymentSpeed.features.1' },
      { text: 'Protège vos données contre les défaillances de disque et les erreurs de stockage.', textKey: 'appCloud.benefits.items.deploymentSpeed.features.2' },
    ],
  },
  {
    id: 2,
    alt: 'Cybersecurity Icon',
    title: 'Flexibilité du cloud',
    titleKey: 'appCloud.benefits.items.cloudFlexibility.title',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    leftTitle: 'Partage en temps réel',
    description: 'Le cloud transforme la gestion de vos applications en éliminant les contraintes matérielles. Adaptez vos ressources en fonction de vos besoins et bénéficiez d\'une évolutivité instantanée.',
    descriptionKey: 'appCloud.benefits.items.cloudFlexibility.description',
    link: '/#',
    features: [
      { text: 'Simplifiez vos échanges et gagnez en efficacité.', textKey: 'appCloud.benefits.items.cloudFlexibility.features.0' },
      { text: 'La solution idéale pour le télétravail.', textKey: 'appCloud.benefits.items.cloudFlexibility.features.1' },
      { text: 'Un accès rapide et illimité à vos données, où que vous soyez.', textKey: 'appCloud.benefits.items.cloudFlexibility.features.2' },
    ],
  },
  {
    id: 3,
    alt: 'Cloud Service Icon',
    title: 'Orchestration experte',
    titleKey: 'appCloud.benefits.items.expertOrchestration.title',
    leftTitle: "Vos données sont sécurité",
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    description: 'IT Monkeys orchestre l\'ensemble du processus de déploiement, garantissant une intégration harmonieuse et sécurisée. Vous restez focalisé sur l\'essentiel : créer des applications exceptionnelles.',
    descriptionKey: 'appCloud.benefits.items.expertOrchestration.description',
    link: '/#',
    features: [
      { text: 'Prévenez les menaces et les pertes de données.', textKey: 'appCloud.benefits.items.expertOrchestration.features.0' },
      { text: 'La tranquillité d\'esprit en sachant que vos données sont en sécurité.', textKey: 'appCloud.benefits.items.expertOrchestration.features.1' },
      { text: 'Amélioration des performances et fonctionnalités.', textKey: 'appCloud.benefits.items.expertOrchestration.features.2' },
      { text: 'Protection contre 99,99% des menaces.', textKey: 'appCloud.benefits.items.expertOrchestration.features.3' },
    ],
  },
  {
    id: 4,
    alt: 'OpenAI Icon',
    title: 'Architecture sur mesure',
    titleKey: 'appCloud.benefits.items.customArchitecture.title',
    leftTitle: 'Boostez votre productivité',
    description: 'Qu\'il s\'agisse d\'architectures traditionnelles, de microservices ou de solutions serverless, nous vous guidons dans le choix de l\'infrastructure optimale pour maximiser la performance et la scalabilité de vos applications.',
    descriptionKey: 'appCloud.benefits.items.customArchitecture.description',
    link: '/#',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    features: [
      { text: 'Connectez vos équipes où qu\'elles soient.', textKey: 'appCloud.benefits.items.customArchitecture.features.0' },
      { text: 'Optimisez la gestion de vos projets.', textKey: 'appCloud.benefits.items.customArchitecture.features.1' },
      { text: 'Planifiez et organisez vos taches.', textKey: 'appCloud.benefits.items.customArchitecture.features.2' },
    ],
  },
  {
    id: 5,
    alt: 'Training Icon',
    title: 'Intégration simplifiée',
    titleKey: 'appCloud.benefits.items.simplifiedIntegration.title',
    leftTitle: 'Soyez accompagné',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    description: 'Nous éliminons les configurations matérielles complexes et les investissements initiaux élevés. Profitez d\'une intégration rapide et efficace pour accélérer vos cycles de développement.',
    descriptionKey: 'appCloud.benefits.items.simplifiedIntegration.description',
    link: '/#',
    features: [
      { text: 'Un contact unique qui comprend vos besoins et vos enjeux.', textKey: 'appCloud.benefits.items.simplifiedIntegration.features.0' },
      { text: 'Réponses et solutions instantanées en cas de problèmes.', textKey: 'appCloud.benefits.items.simplifiedIntegration.features.1' },
      { text: 'Suivi proactif des performances et mises à jour régulières.', textKey: 'appCloud.benefits.items.simplifiedIntegration.features.2' },
    ],
  },
  {
    id: 6,
    alt: 'Training Icon',
    title: 'Sécurité renforcée',
    titleKey: 'appCloud.benefits.items.enhancedSecurity.title',
    leftTitle: 'Une surveillance proactive',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    description: 'La sécurité est au cœur de nos solutions. Nos protocoles robustes assurent la protection de vos applications, vous permettant d\'innover en toute confiance et de respecter les exigences réglementaires.',
    descriptionKey: 'appCloud.benefits.items.enhancedSecurity.description',
    link: '/#',
    features: [
      { text: 'Un contact unique qui comprend vos besoins et vos enjeux.', textKey: 'appCloud.benefits.items.enhancedSecurity.features.0' },
      { text: 'Réponses et solutions instantanées en cas de problèmes.', textKey: 'appCloud.benefits.items.enhancedSecurity.features.1' },
      { text: 'Suivi proactif des performances et mises à jour régulières.', textKey: 'appCloud.benefits.items.enhancedSecurity.features.2' },
    ],
  },
];
